module.exports = __webpack_public_path__ + "img/event-3.157626a.jpg";